import script from "./MobileVecuraPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileVecuraPage.vue?vue&type=script&setup=true&lang=ts"

import "./MobileVecuraPage.vue?vue&type=style&index=0&id=7ccefcce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ccefcce"]])

export default __exports__